import { useTranslation } from 'react-i18next'

import { formatUsd } from '#/shared/lib/format'

import type { MarketRateStats } from '../model/types'

/** SD confidence arrives as either 0–1 or 0–100; normalise to a whole percent. */
export function formatConfidence(value: number): number {
  return Math.round(value <= 1 ? value * 100 : value)
}

/**
 * The resolved market-rate badge — recommended price, per-mile rate, and the
 * provider-confidence pill. Matches Figma 11064-292136: gray-900 price (14px),
 * gray-500 per-mile (10px), and an orange-500 confidence pill.
 */
export function MarketRateStatsBadge({ stats }: { stats: MarketRateStats }) {
  const { t } = useTranslation()
  return (
    <div className="flex h-5 items-center gap-1.25">
      <div className="flex items-baseline gap-1.25">
        <span className="text-sm text-gray-900">
          {formatUsd(stats.recommended)}
        </span>
        {stats.recommendedPerMi !== undefined && (
          <span className="text-2xs text-gray-500">
            {t('table.marketRate.perMi', {
              rate: stats.recommendedPerMi.toFixed(2),
            })}
          </span>
        )}
      </div>
      {stats.confidence !== undefined && (
        <span className="flex items-center justify-center rounded bg-orange-500/10 p-0.5 text-sm text-orange-500">
          {formatConfidence(stats.confidence)}%
        </span>
      )}
    </div>
  )
}
